/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { ComponentChildren } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { Size } from '#utils/UNSAFE_size';
import { View } from '#UNSAFE_View';

type Props = {
  /**
   * Allows to pass and access the properties from child elements
   **/
  children?: (index: number) => ComponentChildren;
  indentation?: Size;
};

/**
 * Allows to specify the time delay for rendering the component
 **/
const timerValue = 50;

/**
 * Represents the skeleton for a tree item in expanding state
 **/
export function NodeSkeletonContainer({ children, indentation = 0 }: Props) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsVisible(true);
    }, timerValue);
  }, []);

  return isVisible && children ? (
    <div role="presentation">
      <View paddingInlineStart={indentation as Size}>
        {[...Array(1)].map((_element, index) => children(index))}
      </View>
    </div>
  ) : null;
}
